module.exports = __webpack_public_path__ + "img/logoHor.13dee593.png";